"use client"

import { useAuthStore } from "@/lib/auth-store"

export function useAuth() {
  const user = useAuthStore((state) => state.user)
  const profile = useAuthStore((state) => state.profile)
  const isLoading = useAuthStore((state) => state.isLoading)
  const isGuest = useAuthStore((state) => state.isGuest)
  const initialize = useAuthStore((state) => state.initialize)
  const signOut = useAuthStore((state) => state.signOut)
  const refreshProfile = useAuthStore((state) => state.refreshProfile)

  return {
    user,
    profile,
    isLoading,
    isAuthenticated: !isGuest && !!user,
    initialize,
    signOut,
    refreshProfile,
  }
}
